<template>
  <el-popover placement="bottom" :disabled="disabled" :width="width" trigger="click" :append-to-body="false" @show="show">
    <el-input ref="input" slot="reference" :disabled="disabled" :value="keyword" clearable :size="size" :placeholder="placeholder" :style="style" @focus="focus" @clear="clear">
      <el-button slot="append" icon="el-icon-search" @click="search" />
    </el-input>

    <template>
      <el-input v-model="textarea" ref="textarea" type="textarea" resize="none" :rows="6" :placeholder="placeholder" />
    </template>
  </el-popover>
</template>

<script>
import uniq from 'lodash/uniq'

export default {
  props: {
    size: {
      type: String,
      required: false,
      default: 'medium'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    width: {
      type: Number,
      required: false,
      default: 298
    },
    placeholder: {
      type: String,
      required: false,
      default: '根据SPU单个/批量搜索'
    }
  },
  data() {
    return {
      keyword: undefined,
      textarea: undefined
    }
  },
  computed: {
    style() {
      return {
        width: `${this.width}px`
      }
    }
  },
  watch: {
    textarea(value) {
      if (value) {
        let result = value.split(/[\r\n]+/).filter((item) => item !== '')
        this.keyword = result.join(',')
      } else {
        this.keyword = undefined
      }
    }
  },
  methods: {
    show() {
      this.$nextTick(() => {
        this.$refs.textarea.focus()
      })
    },

    focus() {
      this.$refs.input.blur()
    },

    clear() {
      this.keyword = undefined
      this.textarea = undefined
      this.$emit('clear')
    },

    search() {
      if (this.keyword && this.keyword.trim()) {
        let keywords = this.keyword.split(',')
        if (keywords.length) {
          this.$emit('search', uniq(keywords.map((item) => item.trim())))
        }
      } else {
        this.$emit('search', [])
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-popover {
  border-radius: 12px;
}
</style>
